export default "__VITE_ASSET__CcZuBoAP__"